import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { finalize } from 'rxjs';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { UploadFileService } from 'src/app/Shared/upload-file.service';
import * as alertify from "alertifyjs";
import { ErrorDialogComponent } from 'src/app/Shared/shared/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/Shared/shared/success-dialog/success-dialog.component';

@Component({
  selector: 'app-crop-profile-picture',
  templateUrl: './crop-profile-picture.component.html',
  styleUrls: ['./crop-profile-picture.component.css']
})
export class CropProfilePictureComponent {
  @Output() cropComplete: EventEmitter<ImageCroppedEvent> = new EventEmitter();
  imageChangedEvent: any = '';

  @Output() onConfirmClicked = new EventEmitter();

  @Input() userId: any;

  imageSrc: any;
  isuploading: boolean;
  success: boolean;
  image: string;
  uploadingMessage: string;
  isUploaded: boolean;
  imageBase64: any;
  isLoading: boolean;



  constructor(
    private bsModalRef: BsModalRef,
    private uploadService:UploadFileService,
    private bsModalService: BsModalService,
    private apiService: ApiServiceService,
) {

}



  imageCropped(event: ImageCroppedEvent) {
    // Check if the blob property is present and not undefined

    if (event.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Convert the blob to base64
        const base64Data = reader.result as string;

        this.imageBase64 = base64Data
      };
      reader.readAsDataURL(event.blob);
    } else {
      console.error('Cropped Image Data: Blob not found in event');
    }
  }
  

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }


  close() {
    this.onConfirmClicked.emit();
    this.bsModalRef.hide();
  }


  selectDocument(event: any) {
    const inputElement = event.target;
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      const reader = new FileReader();
  
      reader.onload = (e) => {

        console.log(e)

        if (e.target && e.target.result) {
          this.imageSrc = e.target.result;
          this.imageChangedEvent = event;
        } else {
          this.confirmAfterError('Error reading the file or invalid file format.');
          alertify.set("notifier", "position", "top-center");
        alertify.error('Error reading the file or invalid file format.');
          
        }
      };
  
      reader.onerror = (e) => {
        this.imageSrc = null;


        console.error('File reading error:');
        this.confirmAfterError('Error reading the file or invalid file format.');
        alertify.set("notifier", "position", "top-center");
      alertify.error('Error reading the file or invalid file format.');
      };
  
      reader.readAsDataURL(file);
    }
  }
  

 
  uploadProfile() {
    this.image = '';
    this.success = false;
    this.isuploading = true;
    this.uploadingMessage = "uploading...";
  
    // Assuming this.imageBase64 is a Blob or File
    let formData: FormData = new FormData();
    let blob = this.dataURItoBlob(this.imageBase64);
formData.append('multipartFile', blob, 'filename.jpg');
  
    this.uploadService.Cloudupload(formData).pipe(
      finalize(() => {}))
      .subscribe((response: any) => {
        if (response.body && response.body.secure_url != '') {
  
          sessionStorage.setItem('image', JSON.stringify(response.body));
          this.image = response.body?.secure_url;

          this.saveProfilePicture()
         
        }
      },
      err => {
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isuploading = false;
      });
  }



  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
  
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([arrayBuffer], { type: 'image/jpeg' });
  }
  

      confirmAfterSuccess(message: any) {
        let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
          initialState: {
            body: message,
          },
          class: "modal-sm modal-dialog-centered",
        });
        dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
          dfModalRef.hide();
        });
      }
    
      confirmAfterError(message: any) {
        let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
          initialState: {
            body: message,
          },
          class: "modal-sm modal-dialog-centered",
        });
        dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
          dfModalRef.hide();
        });
      }

      saveProfilePicture() {
        this.isLoading = true;
    
        let pojo = {

          imageUrl: this.image,

          userId: this.userId

        }
    
        const url = "/auth/save/photo";
    
        this.apiService.loginPost_(url, pojo).subscribe(
          (response) => {
            this.isLoading = false;

          this.success = true;
          this.isUploaded = true;
          this.isuploading = false;
          this.confirmAfterSuccess("Photo uploaded successfully");
          alertify.set("notifier", "position", "top-center");
          alertify.success("Photo uploaded successfully");
          this.isuploading = false;
    
        
          },
          (error) => {
            console.log(error);
            this.confirmAfterError("Action was not successful");
            alertify.set("notifier", "position", "top-center");
            alertify.error("Error performing this operation");
            this.isLoading = false;
          }
        );
      }
    
}